import { localize, setLocale } from '@vee-validate/i18n'
import {
  alpha,
  confirmed,
  digits,
  email,
  length,
  max,
  max_value,
  min,
  min_value,
  numeric,
  one_of,
  regex,
  required,
  url,
} from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

import en from '@vee-validate/i18n/dist/locale/en.json'
import tr from '@vee-validate/i18n/dist/locale/tr.json'

import i18nEn from '@/i18n/en'
import i18nTr from '@/i18n/tr'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()

  defineRule('required', required)
  defineRule('confirmed', confirmed)
  defineRule('min', min)
  defineRule('max', max)
  defineRule('min_value', min_value)
  defineRule('max_value', max_value)
  defineRule('alpha', alpha)
  defineRule('email', email)
  defineRule('one_of', one_of)
  defineRule('numeric', numeric)
  defineRule('length', length)
  defineRule('digits', digits)
  defineRule('url', url)
  defineRule('regex', regex)

  defineRule('id_check', idCheckFunc)

  configure({
    generateMessage: localize({
      en,
      tr,
    }),
  })

  configure({
    generateMessage: localize('tr', {
      names: { ...i18nTr },
    }),
  })
  configure({
    generateMessage: localize('en', {
      names: { ...i18nEn },
    }),
  })

  setLocale('tr')

  function idCheckFunc(value: any, [items]: any) {
    if (!value || !value.length) {
      return true
    }
    const find = items.find((a: any) => a == value)
    if (!find) {
      return nuxtApp.$i18n.t(
        'validation.the_entered_or_selected_value_is_invalid',
      )
    }

    return true
  }
})
